import { postEvent } from "@/lib/api_controller";
import { TaaliaEvent } from "@/lib/event_types";

export default function AppStoreTile({ replyOption, disabled }) {
  const handleButtonClick = (replyOption) => {
    if (disabled) return;
    console.log(`Button clicked with selectionIntent: ${replyOption.selectionIntent}`);
    postEvent(TaaliaEvent.appStoreBadgeClicked, {
      intent: replyOption.selectionIntent,
    });
  };

  return (
    <img
      key={replyOption.selectionIntent}
      src={replyOption.badgeUrl}
      alt={replyOption.title}
      style={{
        height: "3.5rem",
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.5 : 1,
        pointerEvents: disabled ? "none" : "auto",
      }}
      onClick={async () => {
        if (disabled) return;
        await handleButtonClick(replyOption);
        window.open(replyOption.link, "_blank");
      }}
    />
  );
}
